"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var MethodDefinitionTransformer_1;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const TransformationStage_1 = require("../../enums/node-transformers/TransformationStage");
const AbstractNodeTransformer_1 = require("../AbstractNodeTransformer");
const NodeFactory_1 = require("../../node/NodeFactory");
const NodeGuards_1 = require("../../node/NodeGuards");
let MethodDefinitionTransformer = MethodDefinitionTransformer_1 = class MethodDefinitionTransformer extends AbstractNodeTransformer_1.AbstractNodeTransformer {
    constructor(randomGenerator, options) {
        super(randomGenerator, options);
    }
    getVisitor(transformationStage) {
        switch (transformationStage) {
            case TransformationStage_1.TransformationStage.Converting:
                return {
                    enter: (node, parentNode) => {
                        if (parentNode && NodeGuards_1.NodeGuards.isMethodDefinitionNode(node)) {
                            return this.transformNode(node, parentNode);
                        }
                    }
                };
            default:
                return null;
        }
    }
    transformNode(methodDefinitionNode, parentNode) {
        if (NodeGuards_1.NodeGuards.isIdentifierNode(methodDefinitionNode.key)) {
            return this.replaceIdentifierKey(methodDefinitionNode, methodDefinitionNode.key);
        }
        if (NodeGuards_1.NodeGuards.isLiteralNode(methodDefinitionNode.key)) {
            return this.replaceLiteralKey(methodDefinitionNode, methodDefinitionNode.key);
        }
        return methodDefinitionNode;
    }
    replaceIdentifierKey(methodDefinitionNode, keyNode) {
        if (!MethodDefinitionTransformer_1.ignoredNames.includes(keyNode.name)
            && !methodDefinitionNode.computed) {
            methodDefinitionNode.computed = true;
            methodDefinitionNode.key = NodeFactory_1.NodeFactory.literalNode(keyNode.name);
        }
        return methodDefinitionNode;
    }
    replaceLiteralKey(methodDefinitionNode, keyNode) {
        if (typeof keyNode.value === 'string'
            && !MethodDefinitionTransformer_1.ignoredNames.includes(keyNode.value)
            && !methodDefinitionNode.computed) {
            methodDefinitionNode.computed = true;
        }
        return methodDefinitionNode;
    }
};
MethodDefinitionTransformer.ignoredNames = ['constructor'];
MethodDefinitionTransformer = MethodDefinitionTransformer_1 = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Object, Object])
], MethodDefinitionTransformer);
exports.MethodDefinitionTransformer = MethodDefinitionTransformer;
